import React from "react";
import PropTypes from "prop-types";

import tw, { styled } from "twin.macro";

const Content = styled.div`
  ${tw`w-full bg-white border-t-4 border-purple-light lg:border-0`};
`;

const InnerContainer = styled.div`
  ${tw`flex items-center w-full py-10 px-4 md:px-12`};
`;

const InnerContent = styled.div`
  ${tw`my-auto text-lg font-light text-purple-dark md:text-xl`};
`;

const Notice = styled.div`
  ${tw`w-2/3 mt-8 mx-auto py-4 font-black leading-loose text-center text-purple-dark bg-blue-100 rounded-2xl`}
`;

const Biography = ({ notice, children }) => {
  return (
    <Content>
      {notice !== undefined && <Notice dangerouslySetInnerHTML={{ __html: notice }} />}
      <InnerContainer>
        <InnerContent>{children}</InnerContent>
      </InnerContainer>
    </Content>
  );
};

Biography.propTypes = {
  notice: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Biography;
